// extracted by mini-css-extract-plugin
export default {"container":"create_container__ySSGU"};